(function(){
  function loadWidget(loggedIn){
    window._xteticCustomerToken = loggedIn ? 'logged_in' : null;
    var s = document.createElement('script');
    s.src = 'https://xteticsolutions.com/ia/api/widget/xtetic/bundle.js';
    document.head.appendChild(s);
  }
  fetch('/account', { method: 'GET', credentials: 'include' })
    .then(function(r){ loadWidget(!r.url.includes('/login')); })
    .catch(function(){ loadWidget(false); });
})();
